import store from '@/store'

import {RawWikiNode} from '@/types/entity/RawWiki'

import {ActiveFormOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveForm'
import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'

import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'
import TreeSelectField from '@/components/Ui/ActiveForm/BZCore/Fields/TreeSelectField'

// @ts-ignore
import messages from '@/lang/index';

const createForm: ActiveFormOptions = {
  label: messages.wiki.node,
  submitText: messages.wiki.add_node1,
  async onSubmit (data: RawWikiNode) {
    console.log('LOG: create wiki node -> data', data)
    if (!data.parent) data.parent = ''
    await store.dispatch('wiki/createNode', data)
  },
  inputs: {
    title: {
      label: messages.labels.title,
      type: StringField,
      required: true,
      options: {}
    },
    parent: {
      label: messages.wiki.node,
      type: TreeSelectField,
      options: {
        async values (scope: any) {
          let tree = await store.dispatch('wiki/getNodesTree')
          let list = [{title: messages.wiki.main_node, id: '', children: tree}]
          return list;
        },
        treeProps: {
          label: 'title'
        },
        nodeKey: 'id'
      }
    }
  },
  steps: [
    {
      map: [
        ['title', 'parent']
      ]
    }
  ]
}

export default createForm